/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */

export const agentProviderNamePfdc3 = "S&P Global Fusion Peer-to-Peer FDC3 Agent";
